export function OurNumbersSliderOnMobile() {
    const $window = $(window);
    const $slider = $(".our-numbers.slider-on-mobile");
    let dots;
    let arrows;
    let navContainer = "";
    $window.on("load resize", function () {
        $slider.each(function () {
            let $this = $(this);
            if ($this.hasClass("with-navigation")) {
                dots = true;
                arrows = true;
                if ($this.siblings(".slider-nav-holder").length > 0) {
                    navContainer = $this.siblings(".slider-nav-holder");
                }
            } else {
                dots = false;
                arrows = false;
            }
            if ($window.innerWidth() >= 1024) {
                if ($this.hasClass("slick-initialized")) {
                    $this.slick('refresh');
                    $this.slick('unslick');
                }
            } else {
                if (!$this.hasClass("slick-initialized")) {
                    $this.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1.7,
                        infinite: false,
                        arrows: arrows,
                        dots: dots,
                        mobileFirst: true,
                        adaptiveHeight: true,
                        nextArrow: "<button class=\"slide-arrow slick-next\" aria-label='button-next'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\">\n" +
                            "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.7817 8.16251L5.01936 13.9248L4.35645 13.2619L10.1187 7.4996L4.35644 1.7373L5.01936 1.07439L10.7817 6.83669C11.1478 7.2028 11.1478 7.7964 10.7817 8.16251Z\" fill=\"#000EA8\"/>\n" +
                            "</svg></button>",
                        prevArrow: "<button class=\"slide-arrow slick-prev\" aria-label='button-prev'><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\">\n" +
                            "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.21835 6.83749L9.98064 1.0752L10.6436 1.73811L4.88126 7.5004L10.6436 13.2627L9.98064 13.9256L4.21835 8.16331C3.85223 7.7972 3.85223 7.2036 4.21835 6.83749Z\" fill=\"#000EA8\"/>\n" +
                            "</svg></button>",
                        appendArrows: navContainer,
                        appendDots: navContainer,
                        responsive: [
                            {
                                breakpoint: 567,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                        ]
                    });
                }
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/OurNumbersSliderOnMobile.js